export default __webpack_public_path__ + "maps-examples-camera-animators-960-410448cd21f6d6748ee7b1d5a710192d.webp";